import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=5e8380f8"
import script from "./UserCard.vue?vue&type=script&lang=js"
export * from "./UserCard.vue?vue&type=script&lang=js"
import style0 from "./UserCard.vue?vue&type=style&index=0&id=5e8380f8&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e8380f8')) {
      api.createRecord('5e8380f8', component.options)
    } else {
      api.reload('5e8380f8', component.options)
    }
    module.hot.accept("./UserCard.vue?vue&type=template&id=5e8380f8", function () {
      api.rerender('5e8380f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/User/UserCard.vue"
export default component.exports